<template>
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="设备编号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.imeis"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">警告类型</span>
          <el-select v-model="queryParam.trackType" size="mini" placeholder="请选择">
            <el-option
              v-for="item in trackTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">警告时间</span>
          <el-date-picker
            size="mini"
            v-model="warningTime"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #alarmTime="slotData">
        <p>{{leadTime(slotData.data.row.startTime, slotData.data.row.endTime)}}</p>
      </template>
      <template #type="slotData">
        <p v-if="slotData.data.row.type === 'TIME_OUT'">超时分段</p>
        <p v-if="slotData.data.row.type === 'ACC'">acc分段</p>
      </template>
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  created() {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/tqTrackSegment/queryPage",
      },
      queryParam: {},
      trackTypes: [
        { label: "全部", value: "" },
        { label: "超时分段", value: "time_out" },
        { label: "ACC分段", value: "acc" },
      ],
      warningTime: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      dateDefaultShow: "",
      columns: [
        {
          field: "imei",
          fixed: "left",
          label: "设备编号",
        },
        {
          field: "deviceName",
          label: "设备名称",
        },
        {
          field: "mileage",
          label: "总路程(km)",
        },
        {
          field: "alarmTime",
          label: "总用时",
          slotName: "alarmTime",
          columnType: "slot",
        },
        {
          field: "averageSpeed",
          label: "平均速度(km/h)",
        },
        {
          field: "highestSpeed",
          label: "最高时速(km/h)",
        },
        {
          field: "type",
          label: "分段类型",
          slotName: "type",
          columnType: "slot",
        },
        {
          field: "startTime",
          label: "开始时间",
        },
        {
          field: "startAddr",
          label: "开始地点",
        },
        {
          field: "endTime",
          label: "结束时间",
        },
        {
          field: "endAddr",
          label: "结束地点",
        },
        {
          field: "createTime",
          label: "创建时间",
        },
        {
          field: "updateTime",
          label: "修改时间",
        },
      ],
    };
  },
  methods: {
    dateChange(date) {
      if (date) {
        this.queryParam.startTime = date[0];
        this.queryParam.endTime = date[1];
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.warningTime = "";
      this.searchQuery();
    },
    leadTime(startTime, endTime) {
      var date1 = new Date(startTime);
      var date2 = new Date(endTime);
      var difference = date2.getTime() - date1.getTime();
      var hours = Math.floor(difference / (1000 * 60 * 60))
        ? Math.floor(difference / (1000 * 60 * 60)) + "时"
        : "";
      var minutes =
        Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)) + "分";
      var seconds = Math.floor((difference % (1000 * 60)) / 1000) + "秒";
      return `${hours + minutes + seconds}`;
    },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
